<nav class="navigation">
  @if (greaterThanSmall) {
  <stx-nav-bar class="not-print"></stx-nav-bar>
  } @if (!greaterThanSmall) {
  <stx-mobile-nav class="not-print"></stx-mobile-nav>
  }
</nav>
